import { z } from 'zod';

var FontSize = /* @__PURE__ */ ((FontSize2) => {
  FontSize2["XS"] = "xs";
  FontSize2["S"] = "s";
  FontSize2["M"] = "m";
  FontSize2["L"] = "l";
  FontSize2["XL"] = "xl";
  return FontSize2;
})(FontSize || {});
const themeSchema = z.object({
  fontSize: z.object({
    title: z.nativeEnum(FontSize).nullable().optional(),
    text: z.nativeEnum(FontSize).nullable().optional()
  }).optional(),
  fontFamily: z.string().nullable().optional(),
  fontColor: z.object({
    title: z.string().nullable().optional(),
    text: z.string().nullable().optional()
  }),
  background: z.object({
    color: z.string().nullable().optional(),
    image: z.string().nullable().optional(),
    video: z.string().nullable().optional()
  }),
  titleFontFamily: z.string().nullable().optional(),
  shape: z.object({
    largeShapeColor: z.string().nullable().optional(),
    smallShapeColor: z.string().nullable().optional()
  }).optional()
});

export { FontSize, themeSchema };
